import { ThemedStyleFn } from '~src/hooks/useStyles';
import { token } from '@atlaskit/tokens';
import { easeInOut } from '@atlaskit/motion/curves';
import { largeDurationMs, mediumDurationMs } from '@atlaskit/motion/durations';

export const styleFn: ThemedStyleFn = (theme) => ({
  uploadFilesContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 'calc(var(--grid) * 2)',
    flexDirection: 'column',
  },
  fileContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    boxSizing: 'border-box',
    alignItems: 'center',
    justifyContent: 'center',
    background: token('elevation.surface.sunken', '#091E4208'),
    borderRadius: '5px',
    transition: `all ${mediumDurationMs}ms ${easeInOut}`,
    border: '2px dashed transparent',
    width: '100%',
    gap: token('space.300', '24px'),
    minHeight: '100px',
  },
  filesListContainer: { width: '100%', height: '100%' },
  fileItemContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 15px',
    border: `1px solid gray`,
    margin: '5px 0',
    borderRadius: '5px',
  },
  uploadBtnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    marginBottom: 10,
  },
  uploadIcon: {
    marginRight: 10,
  },
  overContainer: {
    background: token('color.background.selected.hovered', '#CCE0FF'),
    color: token('color.text.selected', '#0C66E4'),
    borderColor: token('color.border.brand', '#0C66E4'),
  },
  potentialContainer: {
    borderColor: token('color.border.brand', '#0C66E4'),
  },
  upload: {
    // overflow: 'hidden',
    position: 'relative',
    // using these to hide the details
    borderRadius: 'calc(var(--grid) * 2)',
    overflow: 'hidden',
    transition: `opacity ${largeDurationMs}ms ${easeInOut}, filter ${largeDurationMs}ms ${easeInOut}`,
  },
  loading: {
    opacity: '0',
    filter: 'blur(1.5rem)',
  },
  ready: {
    opacity: '1',
    filter: 'blur(0)',
  },
  displayNoneStyles: {
    display: 'none',
  },
  dragAndDropText: {
    fontSize: '1.4rem',
  },
  fileStyles: {
    display: 'flex',
    flexDirection: 'column',
    padding: 'calc(var(--grid) * 6) calc(var(--grid) * 4)',
    boxSizing: 'border-box',
    alignItems: 'center',
    justifyContent: 'center',
    background: token('elevation.surface.sunken', '#091E4208'),
    borderRadius: 'var(--border-radius)',
    transition: `all ${mediumDurationMs}ms ${easeInOut}`,
    border: '2px dashed transparent',
    width: '100%',
    gap: token('space.300', '24px'),
  },
  textStyles: {
    color: token('color.text.disabled', '#091E424F'),
    fontSize: '1.4rem',
  },
  overStyles: {
    background: token('color.background.selected.hovered', '#CCE0FF'),
    color: token('color.text.selected', '#0C66E4'),
    borderColor: token('color.border.brand', '#0C66E4'),
  },
  potentialStyles: {
    borderColor: token('color.border.brand', '#0C66E4'),
  },
  appStyles: {
    display: 'flex',
    alignItems: 'center',
    gap: 'calc(var(--grid) * 2)',
    flexDirection: 'column',
  },
});
